// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cmbqeyfrirgowoyzjbbe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNtYnFleWZyaXJnb3dveXpqYmJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3NTQ3NjcsImV4cCI6MjA2MjMzMDc2N30.TmA-XQfNLFHoqHO4xUeGfNuFGhxeelP4M0um15gX43Y";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);